import { useEffect } from 'react';
import type { DocumentExchangeResponse } from 'src/apis/document-exchange/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

export function useOptionalDocumentExchangeRoot() {
  const documentExchange = useAxios(
    (axios, baseConfig) =>
      axios.request<DocumentExchangeResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.documentExchange,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'document-exchange-root',
      onError(error) {
        const [_, report] = handleError(error, () => {});
        if (report) reportToSentry(error);
        return error;
      },
    }
  );

  useEffect(() => {
    documentExchange.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return documentExchange;
}

export type OptionalDocumentExchangeRequest = ReturnType<
  typeof useOptionalDocumentExchangeRoot
>;
